import { useQuery } from '@tanstack/react-query';
import { countyBillingService, CountyBillingStatusResponse } from '../services/county-billing.service';

export const useCountyBillingStatus = (enabled = true) => {
  const query = useQuery({
    queryKey: ['county', 'billing-status'],
    queryFn: () => countyBillingService.myStatus(),
    enabled,
    // Re-check every 5 min so a county that gets renewed mid-session sees the change without a full reload.
    refetchInterval: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });

  const data: CountyBillingStatusResponse | undefined = (query.data as any)?.data;

  return {
    status: data?.status,
    config: data?.config ?? null,
    daysRemaining: data?.days_remaining ?? null,
    isTrial: data?.is_trial ?? false,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
};
